import React, { useState, useCallback, useEffect } from "react";
import imagePaths from "../../source/images.json";
import { useTranslation } from "react-i18next";
import UtilMethods from "../../util/UtilMethods";

// Constants
const EVENTS_PATH = process.env.REACT_APP_EVENTS_SOURCE || 'source/events.json';

// Styles
const videoDescAdStyle = {
  textAlign: 'left',
  padding: '0 10px',
  fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)',
  wordBreak: 'break-word'
};

const adSpanStyle = {
  display: 'inline-block',
  marginBottom: '5px'
};

const adLinkStyle = {
  color: "White",
  textDecoration: "underline",
  fontWeight: "bold",
  textShadow: "0 0 8px orange",
  display: 'inline-block',
  wordBreak: 'break-word'
};

const VideoPanel = () => {
  const { t } = useTranslation("labels");
  const { homeVideo } = imagePaths;
  const [activeRetreat, setActiveRetreat] = useState(null);

  // Memoized function to get active retreat
  const getActiveRetreat = useCallback(() => {
    try {
      const events = require(`../../${EVENTS_PATH}`);
      
      const activeEvent = events.find((event) =>
        UtilMethods.canRegister(
          event.reg_date,
          event.reg_end_date || event.start_date
        ) && event.reg_type !== "NO"
      );
      
      setActiveRetreat(activeEvent || null);
    } catch (err) {
      console.error("Error loading events:", err);
      setActiveRetreat(null);
    }
  }, []);

  useEffect(() => {
    getActiveRetreat();
  }, [getActiveRetreat]);

  // Early return if video is not available
  if (!homeVideo) {
    return <div className="alert alert-warning">Video not available</div>;
  }

  return (
    <div className="video-container">
      <video
        id="videoid"
        className="video"
        loop
        autoPlay
        muted
        playsInline
      >
        <source src={homeVideo} type="video/mp4" />
        <source src={homeVideo.replace(".mp4", ".webm")} type="video/webm" />
        Your browser does not support the video tag.
      </video>
      
      <div className="video-text">
        <h1>{t("Grace")}</h1>
        <div className="video-desc">
          <h2>{t("Marian")}</h2>
          <p>{t("Marian_Desc")}</p>
        </div>

        {activeRetreat && (
          <div className="video-desc1 mt-3" style={videoDescAdStyle}>
            <span style={adSpanStyle}>✨ Upcoming Convention ✨ Register 👉</span>
            <a
              href={`${process.env.PUBLIC_URL}/retreat-registration?id=${activeRetreat.id}`}
              className="blink"
              style={adLinkStyle}
            >
              {activeRetreat.name} - {t("Register Now")}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoPanel;
